import React, {useRef, useState} from 'react';
import volunteerQrCode from "../../assets/img/volunteer-qr-code.png";
import pujariQrCode from "../../assets/img/pujari-qr-code.png";
import templeRegistrationQrCode from "../../assets/img/register-temple-qr-code.png";
import poojaShopsQrCode from "../../assets/img/puja-shops-qr-code.png";
import donationQrCode from "../../assets/img/donations-qr-code.png";
import pageAudio from "../../assets/audio/NaathMere.mp3";
import { FaMusic, FaPause } from 'react-icons/fa';

const MahasangamYatra = () => {
    const audioRef = useRef(null);
    const [audioPlayed, setAudioPlayed] = useState(false);

    const playMusic = () => {
        if (audioRef.current) {
            audioRef.current.play().then(() => {
                setAudioPlayed(true);
            }).catch(error => {
                console.log('Autoplay failed:', error);
            });
        }
    }

    const pauseMusic = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            setAudioPlayed(false);
        }
    }

    return (
        <>
            <section
                className="bsb-hero-1 px-3 banner-gradient mahasangam-yatra-banner position-relative">
                <div className='position-absolute d-flex justify-content-center  w-100 mb-3 ' style={{zIndex:'3'}}>
                    <a class="top-button no-underline" href="/join-as-a-volunteer">
                        <button className='px-5'><span className='fs-4'>Join as a volunteer</span></button>
                    </a>
                </div>
            </section>
            <div className="mahasangam-yatra-section-container About-us-inner-banner">
                {/* <div className="row qr-code-desc p-5 align-items-center shadow rounded-5 mx-4 my-3 card-zoom" data-aos="zoom-in-up">
                    <div className='text-start col-md-8 col-12'> 
                        <h1 className='gradient-text display-3 text-white fw-bold mb-2'>Be A Part Of This Divine Journey!</h1> 
                        <p className='fs-3 lead text-white mb-4 lh-sm'>Scan the QR code now to register and join as a <span className='fw-bold fst-italic text-decoration-underline'>Volunteer</span> and contribute to a spiritually uplifting experience. Your dedication can make a difference!
                        </p> 
                    </div>
                    <div className='col-md-4 col-12 text-end'>
                        <img
                        className='col-12 col-md-10 p-1 shadow bg-black rounded-5'
                        src={volunteerQrCode}
                        alt="Volunteer QR Code"
                        />
                        <div style={{
                            display: 'flex',
                            justifyContent: 'end'
                        }}>
                            <div className='col-12 col-md-10 text-center lead lh-sm text-black fw-bold bg-white p-3 mt-3 rounded-5'><span className='text-blink'>Scan QR Code</span></div>
                        </div>
                    </div>
                </div> */}

                <div className="row qr-code-desc p-5 align-items-center shadow rounded-5 mx-4 my-3 card-zoom" data-aos="zoom-in-up">
                    <div className='text-start col-12 col-md-8'> 
                        <h1 className='gradient-text display-3 text-white fw-bold mb-2'>Step Into A Sacred Role!</h1> 
                        <p className='fs-3 lead text-white mb-4 lh-sm'>Scan the QR code now to register and join as a <span className='fw-bold fst-italic text-decoration-underline'>Pujari</span> and be part of this divine service. Embrace the opportunity to connect with the spiritual essence and serve the divine.</p>
                    </div> 
                    <div className='text-end col-12 col-md-4'> 
                        <img
                        src={pujariQrCode}
                        alt="Pujari QR Code"
                        className='col-12 col-md-10 shadow p-1 bg-black rounded-5'
                        />
                        <div style={{
                            display: 'flex',
                            justifyContent: 'end'
                        }}>
                            <div className='col-12 col-md-10 text-center lead lh-sm text-black fw-bold bg-white p-3 mt-3 rounded-5'>
                                <a className='no-underline' href='/join-as-a-pujari'>
                                    <span className='text-blink text-black'>Click here to Join as Pujari</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row qr-code-desc p-5 align-items-center shadow rounded-5 mx-4 my-3 card-zoom" data-aos="zoom-in-up">
                    <div className='text-start col-12 col-md-8'> 
                        <h1 className='gradient-text display-3 text-white fw-bold mb-2'>Connect Your Local Temples To A Divine Network!</h1> 
                        <p className='fs-3 lead text-white mb-4 lh-sm'>Scan the QR code now to <span className='fw-bold fst-italic text-decoration-underline'>Register Temples</span> in your area
                        and help preserve our spiritual heritage. Let’s unite for a greater cause!</p> 
                       
                    </div> 
                    <div className='text-end col-12 col-md-4'> 
                        <img
                        src={templeRegistrationQrCode}
                        alt="Temple Registration QR Code"
                        className='col-12 col-md-10 shadow p-1 bg-black rounded-5'
                        />
                        <div style={{
                            display: 'flex',
                            justifyContent: 'end'
                        }}>
                            <div className='col-12 col-md-10 text-center lead lh-sm text-black fw-bold bg-white p-3 mt-3 rounded-5'>
                                
                                <a className='no-underline' href='/register-temple'>
                                    <span className='text-blink'>Click here to Register a Temple</span>
                                </a>
                 
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row qr-code-desc p-5 align-items-center shadow rounded-5 mx-4 my-3 card-zoom" data-aos="zoom-in-up">
                    <div className='text-start col-12 col-md-8'> 
                        <h1 className='gradient-text display-3 text-white fw-bold mb-2'>Expand Your Puja Shop's Reach!</h1> 
                        <p className='fs-3 lead text-white mb-4 lh-sm'>Scan the QR code now to register your <span className='fw-bold fst-italic text-decoration-underline'>Puja Shop</span> and connect with a wider community of devotees. Let your sacred offerings find the right audience!</p>   
                        
                    </div> 
                    <div className='text-end col-12 col-md-4'> 
                        <img
                        src={poojaShopsQrCode}
                        alt="Pooja Shops QR Code"
                        className='col-12 col-md-10 shadow p-1 bg-black rounded-5'
                        />
                         <div style={{
                            display: 'flex',
                            justifyContent: 'end'
                        }}>
                            <div className='col-12 col-md-10 text-center lead lh-sm text-black fw-bold bg-white p-3 mt-3 rounded-5'>
                                <a className='no-underline' href='/puja-shops'>
                                    <span className='text-blink'>Click here to Register as Puja Shop</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row qr-code-desc p-5 align-items-center shadow rounded-5 mx-4 my-3 card-zoom" data-aos="zoom-in-up">
                    <div className='text-start col-12 col-md-8'> 
                        <h1 className='gradient-text display-3 text-white fw-bold mb-2'>Expand Your Impact Through Generosity!</h1> 
                        <p className='fs-3 lead text-white mb-4 lh-sm'>Scan the QR code now to register for <span className='fw-bold fst-italic text-decoration-underline'>Donations</span> and connect with a compassionate community of donors.
                         Let your noble cause reach those who truly care!</p> 
                    </div> 
                    <div className='text-end col-12 col-md-4'> 
                        <img
                        src={donationQrCode}
                        alt="Donation QR Code"
                        className='col-12 col-md-10 shadow p-1 bg-black rounded-5'
                        />
                        <div style={{
                            display: 'flex',
                            justifyContent: 'end'
                        }}>
                            <div className='col-12 col-md-10 text-center lead lh-sm text-black fw-bold bg-white p-3 mt-3 rounded-5'>
                                <a className='no-underline' href='/join-as-a-donar'>
                                    <span className='text-blink'>Click here to Donate</span>
                                </a>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <audio ref={audioRef} src={pageAudio} preload="auto" />
            {!audioPlayed && <button className="floating-button lead rounded-5 p-3" onClick={playMusic}>
                <FaMusic size={30} className="text-white" />
            </button>}
            {audioPlayed && <button className="floating-button lead rounded-5 p-3" onClick={pauseMusic}>
                <FaPause size={30} className="text-white" />
            </button>}
        </>
    );
};

export default MahasangamYatra;
